var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1C1C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9062 28.125H14.0938C13.6016 28.125 13.25 27.7734 13.25 27.2812C13.25 26.8242 13.6016 26.4375 14.0938 26.4375H25.9062C26.3633 26.4375 26.75 26.8242 26.75 27.2812C26.75 27.7734 26.3633 28.125 25.9062 28.125ZM19.3672 23.3789L14.8672 18.5977C14.5508 18.2461 14.5859 17.7188 14.9023 17.4023C15.2539 17.0859 15.7812 17.0859 16.0977 17.4375L19.1562 20.6719V17.7188V13.2188C19.1562 12.7617 19.5078 12.375 20 12.375C20.457 12.375 20.8438 12.7617 20.8438 13.2188V17.7188V20.6719L23.8672 17.4375C24.1836 17.0859 24.7109 17.0859 25.0625 17.4023C25.4141 17.7188 25.4141 18.2461 25.0977 18.5977L20.5977 23.3789C20.4219 23.5547 20.2109 23.625 20 23.625C19.7539 23.625 19.543 23.5547 19.3672 23.3789Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDownloadIcon);
export default __webpack_public_path__ + "static/media/report_download_icon.86ecfee170b1ee003bf003efdb443920.svg";
export { ForwardRef as ReactComponent };